<template>
  <v-img :src="src" 
         contain
         :height="height"
         @click="onClick"/>
</template>

<style type="text/css" scoped>
   
</style>

<script>
  export default {
    name: 'Logo',

    components:
    {

    },

    mixins: [],

    data: () => ({

    }),

    props: {
      height:
      {
        type: Number,
        default: 50
      },
      app:
      {
        type: Boolean,
        default: false
      }
    },

    computed: 
    {
      src()
      {
        if( this.app )
          return '/images/logo-app.png'

        return '/images/logo.png'
      }
    },

    methods:
    {
      onClick()
      {
        this.$emit('click')
      }
    }
  }
</script>
